import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { Ripple } from "primereact/ripple";
import { Nav } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import CreateModal from "./CreateModal";
import RekapModal from "./RekapModal";
import DeleteModal from "./DeleteModal";
import UpdateModal from "./UpdateModal";

const DetailJadwalkelas = () => {
  const location = useLocation();
  const [key, setKey] = useState("A");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showRekapModal, setShowRekapModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const detailKelas = location.state || {};
  const data = {
    A: [
      {
        tanggal: "21 Oktober 2024",
        jam: "09:00 - 10:00",
        topik: "Pendahuluan",
        tipe: "Perkuliahan",
        ruangan: "501",
        pengajar: "Eveline Margo",
        status: 1,
        id: 110,
      },
      {
        tanggal: "21 Oktober 2024",
        jam: "09:00 - 10:00",
        topik: "Pendahuluan",
        tipe: "TUTORIAL (SESI 2)",
        ruangan: "501",
        pengajar: "Eveline Margo",
        status: 1,
        id: 110,
      },
      // Tambahkan data tambahan untuk Kelompok A jika diperlukan
    ],
    B: [
      {
        tanggal: "21 Oktober 2024",
        jam: "10:00 - 11:00",
        topik: "Praktikum",
        tipe: "Praktikum",
        ruangan: "502",
        pengajar: "Diana Rachmawati",
        status: 0,
        id: 111,
      },
      {
        tanggal: "21 Oktober 2024",
        jam: "11:00 - 12:00",
        topik: "Diskusi",
        tipe: "Diskusi",
        ruangan: "503",
        pengajar: "Fajar Setiawan",
        status: 2,
        id: 112,
      },
      // Tambahkan data tambahan untuk Kelompok B jika diperlukan
    ],
  };

  const rowsOptions = [5, 10, 15];

  const template1 = {
    layout: "PrevPageLink PageLinks NextPageLink ",
    PrevPageLink: (options) => {
      return (
        <button type="button" className="btn border">
          <span className="p-3">Previous</span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button type="button" className="btn border">
          <span className="p-3">Next</span>
          <Ripple />
        </button>
      );
    },
  };

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);

  const onPageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
  };

  const toggleOpenCreateModal = () => {
    setShowCreateModal(true);
  };

  const toggleOpenRekapModal = () => {
    setShowRekapModal(true);
  };

  const toggleOpenDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const toggleOpenUpdateModal = (data) => {
    setSelectedClass(data);
    setShowUpdateModal(true);
  };

  return (
    <div className="container-fluid">
      <div className="card mb-4">
        <div className="card-body">
          <h1>Detail Jadwal Kelas</h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link>Jadwal Kelas</Link>
            </li>
            <li className="breadcrumb-item active">Detail Jadwal Kelas</li>
          </ol>
        </div>
      </div>

      <div className="card">
        <div className="card-body m-3">
          <div
            className="row justify-content-between"
            style={{ margin: "20px 0" }}
          >
            <div className="col-md-12 text-start table-responsive">
              <table style={{ width: "650px" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "175px" }}>Kode MK</td>
                    <td>: {detailKelas.kodeMk}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "175px" }}>Modul</td>
                    <td>: {detailKelas.modul}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "175px" }}>Semester</td>
                    <td>: {detailKelas.semester}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "175px" }}>Kelompok Modul</td>
                    <td>: {detailKelas.kelompokModul}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold" style={{ width: "175px" }}>
                      Total Peserta
                    </td>
                    <td className="fw-bold">: {detailKelas.totalPeserta}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 justify-content-end d-flex gap-1">
              <button
                className="btn btn-success"
                onClick={toggleOpenCreateModal}
              >
                + Tambah Pertemuan
              </button>
              <button
                className="btn btn-primary"
                onClickCapture={toggleOpenRekapModal}
              >
                Rekap <i className="fas fa-file-excel"></i>
              </button>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4 text-center offset-md-4">
              <h4>{key === "A" ? "Kelompok A" : "Kelompok B"}</h4>
            </div>
          </div>

          <div className="row">
            <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
              <Nav variant="pills" className="mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="A">Kelompok A</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="B">Kelompok B</Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="A">
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <label>Show</label>
                      <select
                        value={rows}
                        onChange={(e) => setRows(parseInt(e.target.value))}
                        className="form-select form-select-sm d-inline-block w-auto ms-2"
                      >
                        {rowsOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      <label>entries</label>
                    </div>
                    <div className="col-md-6 text-end">
                      <label>Search :</label>
                      <input
                        type="text"
                        style={{ width: "auto", display: "inline-block" }}
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>
                  <div className="table-responsive">
                    {/* Tabel Data Pengguna */}
                    <table className="table table-striped mt-3">
                      <thead>
                        <tr>
                          <th>NO</th>
                          <th>TANGGAL</th>
                          <th>JAM</th>
                          <th>TOPIK</th>
                          <th>TIPE</th>
                          <th>RUANGAN</th>
                          <th>PENGAJAR</th>
                          <th className="text-center">STATUS</th>
                          <th className="text-center">AKSI</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data[key].map((d, index) => (
                          <tr key={index}>
                            <td>{first + index + 1}</td>
                            <td>{d.tanggal}</td>
                            <td>{d.jam}</td>
                            <td>{d.topik}</td>
                            <td>{d.tipe}</td>
                            <td>{d.ruangan}</td>
                            <td>{d.pengajar}</td>
                            <td>
                              {d.status === 0 ? (
                                <span className="badge text-white text-bg-info">
                                  ON SCHEDULE
                                </span>
                              ) : d.status === 1 ? (
                                <span className="badge text-white text-bg-warning">
                                  ON GOING
                                </span>
                              ) : d.status === 2 ? (
                                <span className="badge text-white text-bg-success">
                                  FINISHED
                                </span>
                              ) : d.status === 3 ? (
                                <span className="badge text-white text-bg-danger">
                                  CANCELED
                                </span>
                              ) : (
                                <span className="badge text-white text-bg-secondary">
                                  UNKNOWN
                                </span>
                              )}
                            </td>
                            <td>
                              <div className="d-flex gap-1">
                                <Link
                                  to={{
                                    pathname: `/akademik/course-attendance/${d.id}`,
                                  }}
                                  state={{ ...d, ...detailKelas }}
                                  className="btn btn-success text-white btn-sm"
                                >
                                  <i className="fa-regular fa-clock"></i>
                                </Link>
                                <Link
                                  to={{
                                    pathname: `/akademik/course-session/history/${d.id}`,
                                  }}
                                  state={{ ...d, ...detailKelas }}
                                  className="btn btn-info text-white btn-sm"
                                >
                                  <i className="fas fa-eye"></i>
                                </Link>
                                <button
                                  className="btn btn-warning text-white btn-sm"
                                  onClick={() => toggleOpenUpdateModal(d)}
                                >
                                  <i className="fa-regular fa-pen-to-square"></i>
                                </button>
                                <button
                                  className="btn btn-danger text-white btn-sm"
                                  onClick={toggleOpenDeleteModal}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Paginator dari PrimeReact */}
                  <div className="row">
                    <div className="col-md-6 d-flex align-items-center h-100">
                      <p>Showing to of entries</p>
                    </div>
                    <div className="col-md-6">
                      <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={data.length}
                        onPageChange={onPageChange}
                        template={template1}
                      />
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="B">
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <label>Show</label>
                      <select
                        value={rows}
                        onChange={(e) => setRows(parseInt(e.target.value))}
                        className="form-select form-select-sm d-inline-block w-auto ms-2"
                      >
                        {rowsOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      <label>entries</label>
                    </div>
                    <div className="col-md-6 text-end">
                      <label>Search :</label>
                      <input
                        type="text"
                        style={{ width: "auto", display: "inline-block" }}
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>

                  <div className="table-responsive">
                    {/* Tabel Data Pengguna */}
                    <table className="table table-striped mt-3">
                      <thead>
                        <tr>
                          <th>NO</th>
                          <th>TANGGAL</th>
                          <th>JAM</th>
                          <th>TOPIK</th>
                          <th>TIPE</th>
                          <th>RUANGAN</th>
                          <th>PENGAJAR</th>
                          <th className="text-center">STATUS</th>
                          <th className="text-center">AKSI</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data[key].map((d, index) => (
                          <tr key={index}>
                            <td>{first + index + 1}</td>
                            <td>{d.tanggal}</td>
                            <td>{d.jam}</td>
                            <td>{d.topik}</td>
                            <td>{d.tipe}</td>
                            <td>{d.ruangan}</td>
                            <td>{d.pengajar}</td>
                            <td>
                              <div className="d-flex justify-content-center">
                                {d.status === 0 ? (
                                  <span className="badge text-white text-bg-info">
                                    ON SCHEDULE
                                  </span>
                                ) : d.status === 1 ? (
                                  <span className="badge text-white text-bg-warning">
                                    ON GOING
                                  </span>
                                ) : d.status === 2 ? (
                                  <span className="badge text-white text-bg-success">
                                    FINISHED
                                  </span>
                                ) : d.status === 3 ? (
                                  <span className="badge text-white text-bg-danger">
                                    CANCELED
                                  </span>
                                ) : (
                                  <span className="badge text-white text-bg-secondary">
                                    UNKNOWN
                                  </span>
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="d-flex gap-1">
                                <button className="btn btn-success text-white btn-sm">
                                  <i className="fa-regular fa-clock"></i>
                                </button>
                                <Link
                                  to={{
                                    pathname: `/akademik/course-session/history/${d.id}`,
                                  }}
                                  className="btn btn-info text-white btn-sm"
                                >
                                  <i className="fas fa-eye"></i>
                                </Link>
                                <button
                                  className="btn btn-warning text-white btn-sm"
                                  onClick={() => toggleOpenUpdateModal(d)}
                                >
                                  <i className="fa-regular fa-pen-to-square"></i>
                                </button>
                                <button
                                  className="btn btn-danger text-white btn-sm"
                                  onClick={toggleOpenDeleteModal}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Paginator dari PrimeReact */}
                  <div className="row">
                    <div className="col-md-6 d-flex align-items-center h-100">
                      <p>Showing to of entries</p>
                    </div>
                    <div className="col-md-6">
                      <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={data.length}
                        onPageChange={onPageChange}
                        template={template1}
                      />
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
      {showCreateModal && <CreateModal toggleModal={setShowCreateModal} />}
      {showRekapModal && <RekapModal toggleModal={setShowRekapModal} />}
      {showDeleteModal && <DeleteModal toggleModal={setShowDeleteModal} />}
      {showUpdateModal && (
        <UpdateModal
          kelas={selectedClass}
          kel={key}
          toggleModal={setShowUpdateModal}
        />
      )}
    </div>
  );
};

export default DetailJadwalkelas;
